import React, { useEffect, useRef, useState } from "react";
import "../styles/SeatPreview.scss";

const CustomerSeatLayout = ({
  sections = [],
  selected = [],
  bookedSeats = [],
  onToggle = () => { },
}) => {
  const layoutRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const resize = () => {
      const maxWidth = window.innerWidth - 40;
      const layoutWidth = layoutRef.current?.offsetWidth || 800;
      setScale(Math.min(1, maxWidth / layoutWidth));
    };
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  return (
    <div className="seat-preview-container">
      <div
        className="seating-layout"
        ref={layoutRef}
        style={{ transform: `scale(${scale})`, transformOrigin: "top center" }}
      >
        {(sections || []).slice().reverse().map((section, sectionIdx) => (
          <div key={section.id}>
            <div className="divider"></div>
            <div className="section-title">
              {section?.name || "Untitled Section"} (EUR {section?.price || "NoPrice"})
            </div>

            <div className="section-blocks-wrapper">
              {(section?.blocks || []).sort((a,b) => a.block_order - b.block_order).map((block, blockIdx) => (
                <div key={block.id} className="block">
                  <div className="block-title">{block?.name || `Block ${blockIdx + 1}`}</div>
                  <div className="block-rows">
                    {(block?.rows || []).slice().sort((a,b) => a.row_order - b.row_order).reverse().map((row, rowIdx) => (
                      <div key={row.id} className="row-container">
                        <div className="row-title">{row?.name || `Row ${rowIdx + 1}`}</div>
                        <div className="seat-row">
                          {(row?.seats || []).sort((a, b) => {
    const posA = a.position ?? a.number ?? 0;
    const posB = b.position ?? b.number ?? 0;
    return posA - posB;
  }).map((seat, index) => {
                            if (seat?.status === "no_seat") {
                              return <div key={index} className="empty-seat" />;
                            }

                            const seatType = seat.seat_type || "available";
                            const isDouble = seatType?.seat_model === "double";
                            const disabledPersonSeat = seatType?.name === "Disabled";
                            const isSelected = selected.includes(seat.id);
                            const isBooked = bookedSeats.includes(seat.id); // booked seats
                            const isDisabled = seat.status === "disabled" || isBooked;



                            return (
                              <div
                                key={seat.id}
                                className={`seat-box 
    ${isDisabled ? "disabled-seat" : ""}
    ${isBooked ? "booked-seat" : ""}
    ${isDouble ? "double-seat" : ""}
    ${isSelected ? "selected-seat" : ""}`}
                                onClick={() => {
                                  if (!isDisabled) onToggle(seat);
                                }}
                                tabIndex={0}
                                role="button"
                                aria-label={`Seat ${seat.number || seat.position} ${isDisabled ? "disabled" : isSelected ? "selected" : "available"}`}
                                style={{
                                  ...(seat.merge_to_left && { marginLeft: 0, borderLeft: 0, borderTopLeftRadius: 0, borderBottomLeftRadius:0  }),
                                  ...(seat.merge_to_right && { marginRight: 0, borderRight: 0, borderTopRightRadius: 0, borderBottomRightRadius:0 }),
                                }}
                              >
                                {disabledPersonSeat ? <p>🦽</p> : seat.number} {seat.suffix ? seat.suffix : null}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerSeatLayout;
